import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from "../views/Guest/Login.vue";
import anasayfa from '../views/Anasayfa.vue';
import {store} from "@/store";
import Guards from "./guards";
Vue.use(VueRouter)

const routes = [
    //{path: '/', redirect:'/login'},
    {
        path: '/login',
        component: LoginPage,
        beforeEnter: Guards.guestOnly,
        meta: {
            title: "Login",
        }
    },
    /*
    Genel
     */
    {
        path: '/genel/sayfalar',
        component: () => import('@/views/Genel/Sayfalar.vue')
    },
    {
        path: '/genel/kullanicilar',
        component: () => import('@/views/Genel/Users.vue')
    },
    {
        path: '/genel/sayfa/:type/:page_id',
        component: () => import('@/views/Genel/SayfaDetay.vue')
    },

    {
        path: '/genel/sss',
        component: () => import('@/views/Genel/SSS.vue')
    },
    {
        path: '/genel/comments',
        component: () => import('@/views/Genel/Comments.vue')
    },
    {
        path: '/genel/formkayitlari',
        component: () => import('@/views/Genel/FormKayitlari.vue')
    },
    {
        path: '/genel/programlar',
        component: () => import('@/views/Genel/Programlar.vue')
    },

    /*
    Site aayarlari
     */
    {
        path: '/ayarlar/siteler',
        component: () => import('@/views/SiteAyarlari/Siteler.vue')
    },
    {
        path: '/ayarlar/siteconfig',
        component: () => import('@/views/SiteAyarlari/SiteConfig.vue')
    },
    {
        path: '/ayarlar/homecards',
        component: () => import('@/views/SiteAyarlari/HomeCards.vue')
    },
    {
        path: '/ayarlar/slider',
        component: () => import('@/views/SiteAyarlari/Slider.vue')
    },
    {
        path: '/ayarlar/banner',
        component: () => import('@/views/SiteAyarlari/Banner.vue')
    },
    {
        path: '/ayarlar/cargo',
        component: () => import('@/views/SiteAyarlari/Cargo.vue')
    },
    {
        path: '/ayarlar/paymenttypes',
        component: () => import('@/views/SiteAyarlari/PaymentTypes.vue')
    },
    {
        path: '/ayarlar/havalebilgileri',
        component: () => import('@/views/SiteAyarlari/Havale.vue')
    },
    {
        path: '/ayarlar/rules',
        component: () => import('@/views/SiteAyarlari/Rules.vue')
    },
    {
        path: '/ayarlar/sablon',
        component: () => import('@/views/SiteAyarlari/Sablon.vue')
    },
    {
        path: '/ayarlar/seosettings',
        component: () => import('@/views/SiteAyarlari/SeoSettings.vue')
    },
    {
        path: '/ayarlar/teknikseo',
        component: () => import('@/views/SiteAyarlari/TeknikSeo.vue')
    },
    {
        path: '/ayarlar/gorsel',
        component: () => import('@/views/SiteAyarlari/GorselAyarlar.vue')
    },
    {
        path: '/ayarlar/ekip',
        component: () => import('@/views/SiteAyarlari/Ekip.vue')
    },

    {path: '/Anasayfa', component: anasayfa},
    //{path: '/', redirect:'/Anasayfa'},
];


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
router.afterEach((to, from) => {
    // ...
    store.dispatch("breadcrumb");
})
export default router
